import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { UserAction } from "../actions";
import * as userApi from "../api/user";
import { toastr } from "react-redux-toastr";
import { goBack } from "connected-react-router";
import { SetMessage } from "../assets/errorMessages";
import logout from "../assets/logout";

export function* watcherUser() {
  yield takeLatest(types.GET_USER_INFO_REQUEST, workerGetInfo);
  yield takeLatest(types.UPDATE_USER_INFO_REQUEST, workerUpdateInfo);
  yield takeLatest(types.CHANGE_PASSWORD_REQUEST, workerChangePassword);
}

function getInfo() {
  return userApi.getInfo();
}
function* workerGetInfo() {
  try {
    const response = yield call(getInfo);
    yield put(UserAction.getInfoSuccess(response.data.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(UserAction.getInfoFailure(message));
  }
}

function updateInfo(data) {
  return userApi.updateInfo(data);
}
function* workerUpdateInfo(action) {
  try {
    const response = yield call(updateInfo, action.data);
    yield put(UserAction.updateInfoSuccess(response.data.data));
    // yield put(InitAction.getSuccess({ userData: response.data.data }));
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(goBack());
  } catch (error) {
    SetMessage(error, true);
    yield put(UserAction.updateInfoFailure());
  }
}

function fetchChangePassword(data) {
  return userApi.changePassword(data);
}
function* workerChangePassword(action) {
  try {
    const response = yield call(fetchChangePassword, action.data);
    yield put(UserAction.changePasswordSuccess());
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    logout();
  } catch (error) {
    SetMessage(error, true);
    yield put(UserAction.changePasswordFailure());
  }
}
